import React from 'react';
import T from 'prop-types';

import { IconButton } from '../../../base_ui';
import { SemiMonthlyRowContainer, SemiMonthlyRowLabel } from './styledComponents';
import iconDictionary from '../../../../utils/iconDictionary';

const CheckedIcon = iconDictionary('approved');
const UncheckedIcon = iconDictionary('unapproved');

const ScheduleSemiMonthlyRow = ({
  label,
  onPress,
  selectedValue,
  value,
}) => {
  const isChecked = selectedValue === value;

  return (
    <SemiMonthlyRowContainer>
      <IconButton
        ariaLabel={`${label} radio button, ${isChecked ? 'checked' : 'unchecked'}`}
        Icon={isChecked ? CheckedIcon : UncheckedIcon}
        onPress={() => onPress(value)}
      />
      <SemiMonthlyRowLabel>{label}</SemiMonthlyRowLabel>
    </SemiMonthlyRowContainer>
  );
};

ScheduleSemiMonthlyRow.propTypes = {
  label: T.string.isRequired,
  onPress: T.func.isRequired,
  selectedValue: T.string.isRequired,
  value: T.string.isRequired,
};

export default ScheduleSemiMonthlyRow;
